<template>
  <div>
    <div class="d-flex flex-row-reverse">
      <v-chip
        id="viewer_pdf__descargar__button"
        class="ma-2"
        label
        color="blue darken"
	      color-text="theme--light"
        :href="urlPDF"
        :disabled="!okPDF"
        v-if="!infoPDF"
      >
      <v-icon left>{{ icon.cloudDownload }}</v-icon>
        Descargar
      </v-chip>
    </div>
    <v-container
      v-if="!infoPDF"
      class="div-preview" 
    >
      <v-progress-circular
        v-if="pdfIsBusy"
        indeterminate
        color="primary"
      ></v-progress-circular>
      <pdf
        v-for="p in numPages"
        :key="p"
        :src="filePDF"
        :page="p"
        @loaded="setPDFOk"
      ></pdf>
    </v-container>
    <v-container v-if="infoPDF">
      <v-card
        class="mx-auto"
        outlined
      >
        <v-list-item three-line>
          <v-list-item-content>
            <v-list-item-title class="headline mb-1">{{labelsPDF.title}}</v-list-item-title>
            <v-list-item-subtitle>{{labelsPDF.message}}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { mdiCloudDownloadOutline } from '@mdi/js'
import {
  viewerPDFData,
  viewerPDFActions
} from '@/modules/signers/store/viewerPDFStoreHelpers'

import pdf from 'vue-pdf'

export default {
  name: 'ViewerPDF',
  data(){
    return {
      icon: {
        cloudDownload: mdiCloudDownloadOutline
      }
    }
  },
  components: {
    pdf
  },
  computed:{
    ...viewerPDFData
  },
  methods:{
    ...viewerPDFActions
  }
}
</script>

<style>
.div-preview {
  overflow-y: scroll;
  height: 90%;
  text-align: center;
}
</style>